import { render } from "./LeftSidebarLayout.vue?vue&type=template&id=4103d9f3"
import script from "./LeftSidebarLayout.vue?vue&type=script&lang=js"
export * from "./LeftSidebarLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/classic/LeftSidebarLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4103d9f3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4103d9f3', __exports__)) {
    api.reload('4103d9f3', __exports__)
  }
  
  module.hot.accept("./LeftSidebarLayout.vue?vue&type=template&id=4103d9f3", () => {
    api.rerender('4103d9f3', render)
  })

}


export default __exports__